// Copyright (C) 2026 — self-hosted Stremio additions
// One renderer for profile avatars so the nav bar, the menu and Settings can
// never disagree about what a profile looks like.
const React = require('react');
const { resolveAvatar } = require('stremio/common/selfHostProfiles');

const ProfileAvatar = ({ profile, size = 32, ring = false, title }) => {
    const a = resolveAvatar(profile);
    const base = {
        flex: 'none',
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        boxShadow: ring ? '0 0 0 2px #fff' : 'none',
        userSelect: 'none'
    };

    if (a.kind === 'image') {
        return (
            <div title={title} style={{ ...base, backgroundColor: '#000' }}>
                <img src={a.src} alt={''} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
        );
    }

    if (a.kind === 'emoji') {
        return (
            <div title={title} style={{ ...base, backgroundColor: a.bg, fontSize: `${Math.round(size * 0.58)}px`, lineHeight: 1 }}>
                <span role={'img'} aria-hidden={true}>{a.emoji}</span>
            </div>
        );
    }

    return (
        <div title={title} style={{ ...base, backgroundColor: a.bg, color: '#fff', fontWeight: 700, fontSize: `${Math.round(size * 0.45)}px` }}>
            {a.text}
        </div>
    );
};

module.exports = ProfileAvatar;
